/**
 * Global search API wrapper for the command palette.
 *
 * Backed by GET /dm-api/search/global which returns four buckets
 * (denials, claims, payers, codes), each capped at `limit` hits.
 */
import { dmClient } from './dmClient';

export async function searchGlobal(q, { types, limit, signal } = {}) {
  const params = {};
  if (q) params.q = q;
  if (types) params.types = Array.isArray(types) ? types.join(',') : types;
  if (limit) params.limit = limit;
  const { data } = await dmClient.get('/search/global', { params, signal });
  return data;
}
